
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { AuthService } from '../_services/auth.service';


@Injectable()
export class UserRoleGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    let roles = route.data['roles'];

    if (!roles || roles.length < 1) {
      throw new Error('UserRoleGuard data not provided: ' + state.url);
    }

    return this.checkRole(roles, state);
  }

  private async checkRole(allowedRoles: string[], state): Promise<boolean> {
    let globals;

    try {
      globals = await this.authService.fetchUserAndUpdateIntoGlobals().toPromise();
    } catch (error) {
      if (this.authService.isInvalidRoleCombinationError(error)) {
        this.authService.redirectToInvalidRoleCombinationError(error);
        return false;
      }
      throw error;
    }

    if (allowedRoles.includes(globals.user.routeRole)) {
      return true;
    }

    // if not allowed role match, maybe a redirect is expected from one role to another
    const redirectUrl = this.getRoleMismatchRedirect(globals.user.routeRole, allowedRoles, state.url);
    if (redirectUrl) {
      this.router.navigate([redirectUrl]);
      return false;
    }

    // instead of revealing that the page exists, just go to 404
    this.router.navigate(['not_found']);
    return false;
  }

  private getRoleMismatchRedirect(actualRole: string, allowedRoles: string[], url: string): string | null {
    if (actualRole === 'site-delegate') {
      if (allowedRoles.includes('worker')) {
        if (url.includes('worker/my-sites')) {
          return '/site-delegate/sites';
        }

        if (url.includes('worker/training')) {
          return url.replace('worker/training', 'site-delegate/training');
        }

        if (url.includes('worker/manage-competencies')) {
          return '/site-delegate/manage-competencies';
        }
      }

      if (allowedRoles.includes('site-owner') && url.includes('site-owner')) {
        return url.replace('site-owner', 'site-delegate');
      }
    }

    if (actualRole === 'admin' && allowedRoles.includes('site-owner') && url.includes('site-owner')) {
      return url.replace('site-owner', 'admin');
    }

    if (actualRole === 'support' && allowedRoles.includes('site-owner') && url.includes('site-owner')) {
      return url.replace('site-owner', 'support');
    }

    if (actualRole === 'support' && allowedRoles.includes('admin') && url.includes('admin')) {
      return url.replace('admin', 'support');
    }

    return null;
  }
}
